import { render, staticRenderFns } from "./data2.vue?vue&type=template&id=27258118&scoped=true&"
import script from "./data2.vue?vue&type=script&lang=js&"
export * from "./data2.vue?vue&type=script&lang=js&"
import style1 from "./data2.vue?vue&type=style&index=1&id=27258118&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27258118",
  null
  
)

export default component.exports